
import React from "react";

export default function BooleanDatatype({ value }) {
  return <span style={{color: '#a6a2ee', fontFamily: 'Roboto Mono'}}>{value.toString()}</span>;
}